export default __webpack_public_path__ + "static/media/grupos xiaomi.1013b661.png";